var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.646 10.8333V1.5M19.9793 20.1667V16.6667M3.646 20.1667V15.5M19.9793 12V1.5M11.8127 5V1.5M11.8127 20.1667V9.66667",
    stroke: "#939393",
    strokeWidth: 1.16667,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64583 15.4999C4.9345 15.4999 5.97917 14.4552 5.97917 13.1666C5.97917 11.8779 4.9345 10.8333 3.64583 10.8333C2.35717 10.8333 1.3125 11.8779 1.3125 13.1666C1.3125 14.4552 2.35717 15.4999 3.64583 15.4999Z",
    stroke: "#939393",
    strokeWidth: 1.16667,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8123 9.66667C13.101 9.66667 14.1457 8.622 14.1457 7.33333C14.1457 6.04467 13.101 5 11.8123 5C10.5237 5 9.479 6.04467 9.479 7.33333C9.479 8.622 10.5237 9.66667 11.8123 9.66667Z",
    stroke: "#939393",
    strokeWidth: 1.16667,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9793 16.6667C21.268 16.6667 22.3127 15.622 22.3127 14.3333C22.3127 13.0447 21.268 12 19.9793 12C18.6907 12 17.646 13.0447 17.646 14.3333C17.646 15.622 18.6907 16.6667 19.9793 16.6667Z",
    stroke: "#939393",
    strokeWidth: 1.16667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.74c8911c308674c6dbe26f99e11142e2.svg";
export { ForwardRef as ReactComponent };